import {CurrentUserAdapter} from './current-user-adapter.service';
import { EncrptPayloadAdapter } from './encrpt-payload-adapter.service';
import {LoginAdapter} from './login-adapter.service';

export const Adapters = [CurrentUserAdapter, LoginAdapter,EncrptPayloadAdapter];
